import { connectRouter } from 'connected-react-router/immutable';
import { combineReducers } from 'redux-immutable';
import { reducers } from '../modules';

export default (history) => combineReducers({
  ...reducers,
  router: connectRouter(history)
});
